module.exports = __webpack_public_path__ + "media/src/images/favicons/favicon-128-303ef1a6804f2bc32361c270f601e848.png";